import i18n from 'i18next';

import getExistingVideos from '../helpers/getExistingVideos';

export default ({ adminSettings, type }) => {
  const { data: { locales = [] } = {} } = adminSettings;

  if (type === 'new-topic') {
    return {
      title: {
        type: 'Text',
        label: i18n.t('title'),
        validators: [{ type: 'isRequired' }],
      },
      description: {
        type: 'TextArea',
        label: i18n.t('description'),
        validators: [{ type: 'isRequired' }],
      },
      code: {
        type: 'Text',
        label: i18n.t('code'),
      },
      locale: {
        type: 'Select',
        label: i18n.t('locale'),
        isFluid: true,
        selectProps: {
          placeholder: i18n.t('locales-placeholder'),
          noOptionsMessage: () => i18n.t('locales-empty'),
        },
        options: locales.map(({ key, name }, i) => ({
          id: i,
          label: name,
          value: key,
        })),
        validators: [{ type: 'isRequired' }],
      },
    };
  }

  if (type === 'new-video') {
    return {
      title: {
        type: 'Text',
        label: 'Video Title',
        validators: [{ type: 'isRequired' }],
      },
      video_source: {
        type: 'Select',
        label: i18n.t('video-source'),
        help: i18n.t('video-source-label'),
        isFluid: true,
        selectProps: {
          placeholder: i18n.t('video-source-placeholder'),
          noOptionsMessage: () => i18n.t('video-source-empty'),
        },
        options: [
          {
            id: 1,
            value: 'upload',
            label: 'Upload',
          },
          {
            id: 2,
            label: 'URL',
            value: 'url',
          },
        ],
        validators: [{ type: 'isRequired' }],
      },
      upload_url: {
        type: 'Upload',
        label: i18n.t('upload-video'),
        help: i18n.t('video-source-label'),
        uploadType: 'video',
        maxUploadSize: 3000,
        hasReplaceUploadButton: true,
        replaceUploadButtonText: i18n.t('replace-video'),
        uploadButtonText: i18n.t('upload-file'),
        removeButtonText: i18n.t('remove-video'),
        validators: [{ type: 'isRequiredIfVisible' }],
        conditions: [{ type: 'videos:isVideoSourceUpload', shouldHideField: true }],
        permittedFormats: 'video/*',
      },
      url: {
        type: 'Text',
        label: i18n.t('video-url'),
        help: i18n.t('video-url-help'),
        validators: [{ type: 'isRequiredIfVisible' }],
        conditions: [{ type: 'videos:isVideoSourceURL', shouldHideField: true }],
      },
      locale: {
        type: 'Select',
        label: i18n.t('locale'),
        selectProps: {
          placeholder: i18n.t('locales-placeholder'),
          noOptionsMessage: () => i18n.t('locales-empty'),
        },
        options: locales.map(({ key, name }, i) => ({
          id: i,
          label: name,
          value: key,
        })),
        validators: [{ type: 'isRequired' }],
      },
    };
  }

  if (type === 'existing-video') {
    return {
      existing_video: {
        type: 'SelectWithLoadOptions',
        label: i18n.t('video-search-label'),
        help: i18n.t('video-search-help'),
        selectProps: {
          hasEmptyOptionsMessage: true,
          isFluid: true,
          isFullWidth: true,
          isSearchable: true,
          loadingMessage: () => i18n.t('loading'),
          loadOptions: getExistingVideos,
          noOptionsMessage: () => i18n.t('existing-video-empty'),
          placeholder: i18n.t('existing-video-placeholder'),
        },
        validators: [{ type: 'isRequired' }],
      },
    };
  }
};
